export default String.raw`

{% assign baseProduct = product-presentation.Product -%}

{% comment -%}<!-- Sets -->{% endcomment -%}
{% if product.SetsExt != null and product.SetsExt != empty -%}
	<div class="sets-container sets-js">
		<h2>{{ translations.BuyInSet }}</h2>
  		{% for set in product.SetsExt -%}
		  	{% assign setPrice = '' -%}
		  	{% assign setPreviousPrice = '' -%}
			{% assign setDeposit = '' -%}
			{% assign setIndex = forloop.index0 -%}
			<div class="add-to-cart-form-container-js">
				<h3>{{ set.SetName }}</h3>
				<div class="sets-details form-js need-product-id-js add-to-cart-js add-set-to-cart-js {% if customer.HidePrices -%} hidden-set-prices {% endif -%}">
				  	<div class="sets">
						<div class="sets__swiper">
							<div class="mask-left"></div>
							<div class="mask-right"></div>
							<div class="swiper-wrapper">
								{% assign additionalIndex = 0 -%}
								{% assign totalSetElements = set.Elements | Size -%}
								{% for setElement in set.Elements -%}
									{% for setProduct in setElement.Products -%}
										{% assign index = forloop.index -%}
										{% assign additionalIndex = additionalIndex | Plus: 1 -%}
										{% if index == 1 -%}
											{% if setProduct.Value -%}
												{% if setPrice == '' -%}
													{% assign setPrice = setProduct.Value -%}
												{% else -%}
													{% assign setPrice = setPrice | Plus: setProduct.Value -%}
												{% endif -%}
											{% endif -%}
											{% if setProduct.DepositValue -%}
												{% if setDeposit == '' -%}
													{% assign setDeposit = setProduct.DepositValue -%}
												{% else -%}
													{% assign setDeposit = setDeposit | Plus: setProduct.DepositValue -%}
												{% endif -%}
											{% endif -%}
											{% if setProduct.PreviousValue -%}
												{% if setPreviousPrice == '' -%}
													{% assign setPreviousPrice = setProduct.PreviousValue -%}
												{% else -%}
													{% assign setPreviousPrice = setPreviousPrice | Plus: setProduct.PreviousValue -%}
												{% endif -%}
											{% endif -%}
										{% endif -%}
										<div class="swiper-slide sets__wrapper set-product-js {% if index > 1 -%} set-product-hidden-js {% endif -%}" data-index="{{ forloop.index }}"  data-set-element-id="{{setElement.SetElementId}}" data-set-product-id="{{setProduct.SetProductId}}" data-set-product-value="{{setProduct.Value}}" data-set-product-previous-value="{{setProduct.PreviousValue}}" data-id="{{setProduct.Id}}" data-name="{{setProduct.NameNoHtml | H}}" data-price="{{setProduct.Price}}" data-deposit-price="{{setProduct.DepositValue}}" data-price-full="{{setProduct.Price | ToPrice}}" data-quantity="{{setProduct.Quantity | Normalize}}">
											<div class="product-info expandable-mechanism-container-js">
												<a href="{{ page.BaseHref }}{{ setProduct.Url }}">
													{% if setProduct.Image != null -%}
														{{ setProduct | Img:'medium' }}
													{% else -%}
														<svg class="no-image">
															<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#image-{{settings.iconStyle}}"></use>
														</svg>
													{% endif -%}
													<div class="flags">
														{% if product.Archival -%}
															<div class="tile archival">{{ translations.ArchivalProduct}}</div>
														{% endif -%}
														{% if setProduct.FreeProduct -%}
															<span class="tile free">{{ translations.Free }}!</span>
														{% endif %}
														{% if setProduct.Quantity != 1 -%}
															{% assign quantity = setProduct.Quantity -%}
															{% unless config.Products.DecimalUnits -%}
																{% assign quantity = setProduct.Quantity | Normalize -%}
															{% endunless -%}
															<span class="tile set-quantity">{{ quantity }} {{ setProduct.Unit }}</span>
														{% endif -%}
													</div>
												</a>
												<div class="name" title="{{ setProduct.NameNoHtml }}">{{ setProduct.NameNoHtml }}</div>
												{% unless customer.HidePrices -%}
													<div class="price-details">
														<div class="current-price">{{ setProduct.Value }} {{ customer.CurrencyExt }}</div> 
														{% if setProduct.Value != setProduct.PreviousValue and settings.previousPriceAsSuggestedRetailPrice != 'yes' -%}
															<div class="previous-price">{{ setProduct.PreviousValue }} {{ customer.CurrencyExt }}</div>
														{% endif -%}
														{% if customer.Cart.SubtotalPrices -%}
															<div>{{ translations.Netto | Downcase }}</div>
														{% else -%}
															<div>{{ translations.Brutto | Downcase }}</div>
														{% endif -%} 
													</div>
													{% if setProduct.DepositValue > 0 -%}
														<small class="related-product__price-deposit">
															<div>+ {{ translations.Com_Deposit }}: {{ setProduct.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ customer.CurrencyExt }} / {{ setProduct.Unit }}</div>
														</small>
													{% endif -%}
													{% if setProduct.Value != setProduct.PreviousValue and settings.previousPriceAsSuggestedRetailPrice == 'yes' -%}
														<div class="retail-price">
															{{ setProduct.PreviousValue }} {{ customer.CurrencyExt }}
															{% if customer.Cart.SubtotalPrices -%}
																{{ translations.Netto | Downcase }}
															{% else -%}
																{{ translations.Brutto | Downcase }}
															{% endif -%} 
															- {{translations.SuggestedRetailPrice}}
														</div>
													{% endif -%}
												{% endunless -%}
												{% if setProduct.AttributesPolyvalent or setProduct.AttributesEditable -%}
													<button class="pure-button expand-data-js change-arrow-title-js" title="{{ translations.ShowDetails }}">
														{{ translations.Attributes }}
														<svg height="16" width="16" class="icon rotate-down dropdown-arrow">
															<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
														</svg>
													</button>
													<div class="expand-attributes expandable-js">
														{% for attribute in setProduct.AttributesPolyvalent -%}
															<div class="form__input-wrapper attributes-js">
																<label for="attributePolyvalent" class="form__input-info input-info-js on-label">{{ attribute.Name }}</label>
																<div tabindex="0" class="form__input-value select select-js" title="{{ attribute.Name }}" aria-expanded="false">
																	<select class="memory-js" aria-label="attributePolyvalent" name="attributePolyvalent" data-id="{{ attribute.Id }}">
																		{% for value in attribute.Values -%}
																			<option value="{{ value.ValueId }}">
																			{{ value.Value | H }}
																			</option>
																		{% endfor -%}
																	</select>
																	<div class="select__input" style="height: 24px;">
																	<span class="selected-js" title="{{ attribute.Values[0].Value }}">
																		{{ attribute.Values[0].Value }}
																	</span>
																	<svg width="16" height="16">
																		<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{ settings.iconStyle }}"></use>
																	</svg>
																	</div>
																	<ul class="select__options options-js" role="menu">
																	{% for value in attribute.Values -%}
																		<li tabindex="-1" data-value="{{ value.ValueId }}">{{ value.Value }}</li>
																	{% endfor -%}
																	</ul>
																</div>
															</div>
														{% endfor -%}
														{% for attribute in setProduct.AttributesEditable -%}
															<div class="form__input-wrapper">
																{% case attribute.Format -%}
																	{% when 1 -%}
																		<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js">{{ attribute.Name }} <span class="required">*</span></label>
																		<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="text" name="attributeEditable" value="" maxlength="50" required data-id="{{attribute.Id}}" />
																		<div class="form__input-value--clear-button">
																			<svg>
																				<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
																			</svg>
																		</div>	
																	{% when 2 -%}
																		<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js">{{ attribute.Name }} <span class="required">*</span></label>
																		<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="number" name="attributeEditable" value="" max="999999999999999" required data-id="{{attribute.Id}}" />
																	{% when 3 -%}
																		<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js">{{ attribute.Name }} <span class="required">*</span></label>
																		<div tabindex="0" class="select select-js">
																			<select id="attribute-edit-{{forloop.index}}" class="memory-js" name="attributeEditable" data-id="{{attribute.Id}}">
																				{% for val in attribute.Values %}
																					<option {% if val.ValueId == attribute.Values[0].ValueId -%} selected {% endif -%} value="{{ val.ValueId }}">{{ val.Value }}</option>
																				{% endfor -%}
																			</select>
																			<div class="select__input">
																				<span class="selected-js" title="{{ attribute.Values[0].Value }}">
																					{{ attribute.Values[0].Value }}
																				</span>
																				<svg width="16" height="16">
																					<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
																				</svg>
																			</div>
																			<ul class="select__options options-js">
																				{% for val in attribute.Values %}
																					<li tabindex="-1" data-value="{{ val.ValueId }}">{{ val.Value }}</li>
																				{% endfor -%}
																			</ul>
																		</div>
																	{% when 4 -%}
																		<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js on-label">{{ attribute.Name }} <span class="required">*</span></label>
																		<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="date" name="attributeEditable" value="" required data-id="{{attribute.Id}}" />
																{% endcase -%}
																<div class="form__invalid-input validation-info-js validation-required-js hidden-js">
																	{{ translations.FillAttributeValue }}
																</div>
															</div>
														{% endfor -%}
													</div>
												{% endif -%}
												{% if setProduct.Supplies.Key != null -%}
													<div class="set-product-supplies container-js" data-template="partials/product/set-product-supplies.html">
														{% include 'partials/product/set-product-supplies.html' with setProduct -%}
													</div>
												{% endif -%}
												{% assign setElementProductsSize = setElement.Products | Size -%}
												{% if setElementProductsSize > 1 -%}
													<button class="open-set-element-products-popup-js">{{ translations.Change }}</button>
												{% endif -%}
											</div>
											{% if additionalIndex != totalSetElements %}
												<div class="sets__plus">
													<svg class="plus-icon">
														<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#plus-circle-{{ settings.iconStyle }}'></use>
													</svg>
												</div>
											{% endif %}
										</div>
									{% endfor -%}
								{% endfor -%}
							</div>
							<div class="arrow shadowed sets__prev">
								<svg class="arrow__icon">
									<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use>
								</svg>
							</div>
							<div class="arrow shadowed sets__next">
								<svg class="arrow__icon">
									<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use>
								</svg>
							</div>
						</div>

						{% for setElement in set.Elements -%}
							<div class="message-popup-background hidden-js hide-js container-to-hide-js" data-set-element-products-popup="{{setElement.SetElementId}}">
								<div class="message-popup" style="overflow: auto;">
									<button class="close-button hide-container-js" aria-label="{{ translations.Close }}">
                        				<svg aria-hidden="true" width="24" height="24" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use></svg>
									</button>
									{% for setProduct in setElement.Products -%}
										<div class="change-set-element-product-js" data-set-product-id="{{setProduct.SetProductId}}">
											<figure>
												{{ setProduct | Img:'medium' }}
												<div class="flags">
													{% if setProduct.FreeProduct -%}
														<span class="free">{{ translations.Free }}!</span>
													{% endif %}
													{% if setProduct.Quantity != 1 -%}
														{% assign quantity = setProduct.Quantity -%}
														{% unless config.Products.DecimalUnits -%}
															{% assign quantity = setProduct.Quantity | Normalize -%}
														{% endunless -%}
														<span class="free">{{ quantity }}{{ setProduct.Unit }}</span>
													{% endif -%}
												</div>
											</figure>
											<div class="name">{{ setProduct.NameNoHtml }}</div>
										</div>
									{% endfor -%}
								</div>
							</div>
						{% endfor -%}
				  	</div>
					{% unless customer.HidePrices -%}
					  	<div class="sets__price-details">
							<div class="prices">
								<div>
									{{ translations.BuySetFor }}:
								</div>
								<div class="main-price">
									{% if customer.Cart.SubtotalPrices -%}
										<div class="netto-js"><span class="value-js">{{ setPrice | Round: config.DecimalPlacesPrice | ToPrice }}</span> {{ customer.CurrencyExt }}</div>
										<div>{{ translations.Netto | Downcase }}</div>
									{% else -%}
										<div class="brutto-js"><span class="value-js">{{ setPrice | Round: config.DecimalPlacesPrice | ToPrice }}</span> {{ customer.CurrencyExt }}</div>
										<div>{{ translations.Brutto | Downcase }}</div>
									{% endif -%}
								</div>
								{% if setDeposit > 0 -%}
									<div class="deposit-price">
										<div>+ {{ translations.Com_Deposit }}: <span class="deposit-value-js">{{ setDeposit | Round: config.DecimalPlacesPrice | ToPrice }}</span> {{ customer.CurrencyExt }}</div>
									</div>
								{% endif -%}
								<div class="previous-price old-price-js {% if setPreviousPrice <= setPrice or setPreviousPrice == 0 -%} hidden-js {% endif -%}">
									{% if settings.previousPriceAsSuggestedRetailPrice != 'yes' -%}
										<span class="value value-js">
											{{ setPreviousPrice | Round: config.DecimalPlacesPrice | ToPrice }} {{ customer.CurrencyExt }}
										</span>
										{% if customer.Cart.SubtotalPrices -%}
											{% unless setPreviousPrice <= setPrice or setPreviousPrice == 0 -%}
												{{ translations.Netto | Downcase }} 
											{% endunless -%} 
										{% else -%}
											{% unless setPreviousPrice <= setPrice or setPreviousPrice == 0 -%}
												{{ translations.Brutto | Downcase }} 
											{% endunless -%} 
										{% endif -%}
									{% else -%}
										<span class="value-js">
											{{ setPreviousPrice | Round: config.DecimalPlacesPrice | ToPrice }} {{ customer.CurrencyExt }} 
											{% if customer.Cart.SubtotalPrices -%}
												{% unless setPreviousPrice <= setPrice or setPreviousPrice == 0 -%}
													{{ translations.Netto | Downcase }} 
												{% endunless -%} 
											{% else -%}
												{% unless setPreviousPrice <= setPrice or setPreviousPrice == 0 -%}
													{{ translations.Brutto | Downcase }} 
												{% endunless -%} 
											{% endif -%}
											- {{translations.SuggestedRetailPrice}}
										</span>
									{% endif -%}
								</div>
								<div class="saved {% if setPreviousPrice <= setPrice or setPreviousPrice == 0 -%} hidden-js {% endif -%}">
									<div class="saved-money-js">
										<span>{{ translations.SavingMoney }}: </span><span class="value-js">{{ setPrice | Minus: setPreviousPrice | Abs | Round: config.DecimalPlacesPrice | ToPrice }}</span> {{ customer.CurrencyExt }}
									</div>
								</div>
							</div>
							{% if setPrice > 0 -%}
								<button aria-label="add-to-cart-button" class="primary-action-button add-to-cart-button-js add-to-cart-update-client-area-js parent-container-reload-js" {% if newQuery and settings.afterAddingToCart != 1 -%}data-url="{{ dataUrl }}"{% endif -%}{% if customer.Carts[1] -%} data-current-cart-id="{{ currentCartId }}" {% endif -%} data-set-id="{{ set.SetId }}">
									<span class="add-to-cart-label-js">
										{% capture mid -%}{% endcapture -%}
										{% capture end -%} <span class="cart-name-js"> {{ currentCartName }}</span>{% endcapture -%}
										{% assign cartsAmount = customer.Carts | Size -%}
										{% if customer.Cart.EditedOrderId or cartsAmount > 1 -%}
											{% if customer.Cart.EditedOrderId -%}
												{% assign end = end | Prepend:mid -%}
												{{ translations.AddToOrderSplitted | Format: end }}
											{% elseif customer.Cart.Inquiry -%}
												{{ translations.AddToInquirySplitted | Format: mid }}
											{% else -%}
												{{ translations.AddToCartSplittedWithName | Format: mid,end }}
											{% endif -%}
										{% elseif customer.Cart.Inquiry -%}
											{{ translations.AddToInquirySplitted | Format: mid }}
										{% else -%}
											{{ translations.AddToCartSplitted | Format: mid }}
										{% endif -%}
									</span>
									{% if customer.Cart.EditedOrderId -%}
										<svg class="primary-action-button__icon">
											<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#shopping-cart-{{settings.iconStyle}}"></use>
										</svg>
									{% elseif customer.Cart.Inquiry -%}
										<svg class="primary-action-button__icon">
											<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#shopping-cart-{{settings.iconStyle}}"></use>
										</svg>
									{% else -%}
										<svg class="primary-action-button__icon">
											<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#shopping-cart-{{settings.iconStyle}}"></use>
										</svg>
									{% endif -%}
								</button>
							{% endif -%}
						</div>
					{% endunless -%}
				</div>
		  	</div>
	  	{% endfor -%}
	</div>
{% endif -%}

{% comment -%}<!-- Accessories -->{% endcomment -%}
{% if baseProduct.RelatedProducts.Accessories[0] -%}
	<div class="related-container related-accessories-js">
		<h2>{{ translations.Accessories }}</h2>
		<div class="related-details">
			<div class="related">
				{% include 'partials/product/recommended-products.html', products: baseProduct.RelatedProducts.Accessories, isDiscountItem: false, section: 'Accessories' -%}
			</div>
		</div>
	</div>
{% endif -%}

{% comment -%}<!-- Cross-selling -->{% endcomment -%}
{% if baseProduct.RelatedProducts.Crossselling[0] -%}
	<div class="related-container related-crossseling-js">
		<h2>{{ translations.OthersAlsoBought }}</h2>
		<div class="related-details">
			<div class="related">
				{% include 'partials/product/recommended-products.html', products: baseProduct.RelatedProducts.Crossselling, isDiscountItem: false, AIRecommendations: config.Products.AIEnabled, section: 'Crossselling' -%}
			</div>
		</div>
		{% if config.Products.AIEnabled -%}
			<div class="ai-generated-content">{{ translations.AiGeneratedProductsRecommendations }}</div>
		{% endif -%}
	</div>
{% endif -%}

{% comment -%}<!-- Custom Products -->{% endcomment -%}
{% if baseProduct.RelatedProducts.Custom[0] -%}
	{% for custom in baseProduct.RelatedProducts.Custom -%}
		<div class="related-container related-custom-js">
			<h2>{{ custom.RelationName }}</h2>
			<div class="related-details">
				<div class="related">
					{% include 'partials/product/recommended-products.html', products: custom.Products, isDiscountItem: false, section: 'Custom-' | append: forloop.index -%}
				</div>
			</div>
		</div>
	{% endfor -%}
{% endif -%}

{% comment -%}<!-- Substitutes -->{% endcomment -%}
{% if baseProduct.RelatedProducts.Substitutes[0] -%}
	<div class="related-container related-substitutes-js">
		<h2>{{ translations.Substitutes }}</h2>
		<div class="related-details">
			<div class="related">
				{% include 'partials/product/recommended-products.html', products: baseProduct.RelatedProducts.Substitutes, isDiscountItem: false, section: 'Substitutes' -%}
			</div>
		</div>
	</div>
{% endif -%}

{% comment -%}<!-- Suggested -->{% endcomment -%}
{% if baseProduct.RelatedProducts.Suggested[0] -%}
	<div class="related-container related-suggested-js">
		<h2>{{ translations.Suggested }}</h2>
		<div class="related-details">
			<div class="related">
				{% include 'partials/product/recommended-products.html', products: baseProduct.RelatedProducts.Suggested, isDiscountItem: false, section: 'Suggested' -%}
			</div>
		</div>
	</div>
{% endif -%}

{% comment -%}<!-- AI Products Recommendations -->{% endcomment -%}
{% if baseProduct.RelatedProducts.AIProductsRecommendations[0] -%}
	<div class="related-container related-ai-js">
		<h2>{{ translations.SimilarProducts }}</h2>
		<div class="related-details">
			<div class="related">
				{% include 'partials/product/recommended-products.html', products: baseProduct.RelatedProducts.AIProductsRecommendations, isDiscountItem: false, AIRecommendations: config.Products.AIEnabled, section: 'AIProductsRecommendations' -%}
			</div>
		</div>
		{% if config.Products.AIEnabled -%}
			<div class="ai-generated-content">{{ translations.AiGeneratedProductsRecommendations }}</div>
		{% endif -%}
	</div>
{% endif -%}
`